import { render, staticRenderFns } from "./Page-FiscalIssuance.vue?vue&type=template&id=06e42d64&"
import script from "./Page-FiscalIssuance.vue?vue&type=script&lang=js&"
export * from "./Page-FiscalIssuance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports